module.exports = __webpack_public_path__ + "img/MES10Area_selection.9b978603.png";